var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureFabric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a20",
    x1: 2525.57,
    y1: -412.026,
    x2: 2525.544,
    y2: -402.136,
    gradientTransform: "matrix(.5 .001 .001 -.5 -1257.171 -191.917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa21d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b20",
    x1: 12.79,
    y1: 17.38,
    x2: 12.79,
    y2: 12.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa21d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c20",
    x1: 15.3,
    y1: 9.98,
    x2: 15.3,
    y2: 5.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa21d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d20",
    x1: 2.7,
    y1: 9.98,
    x2: 2.7,
    y2: 5.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa21d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e20",
    x1: 9,
    y1: 5.56,
    x2: 9,
    y2: 0.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa21d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.2l-5.76-4.11L9 2.18l-1.22.9L2 7.2 4.25 14l.47 1.44h8.6l.45-1.44L16 7.25zM5.76 14l-2-6.22L9 4l5.28 3.79-2 6.22z",
    fill: "#e27908"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.07,
    cy: 14.91,
    r: 2.47,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.79,
    cy: 14.91,
    r: 2.47,
    fill: "url(#b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3,
    cy: 7.51,
    r: 2.47,
    fill: "url(#c)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.7,
    cy: 7.51,
    r: 2.47,
    fill: "url(#d)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3.09,
    r: 2.47,
    fill: "url(#e)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureFabric);
export default __webpack_public_path__ + "static/media/azure-fabric.c6f9907e49498019802a4469e44d1e1a.svg";
export { ForwardRef as ReactComponent };